import { FormField, FormFieldNameEnum, FormFieldType } from "@/types/form";

export const registerFormFields: FormField[] = [
  { field: FormFieldNameEnum.Name, type: FormFieldType.Text },
  { field: FormFieldNameEnum.Email, type: FormFieldType.Email },
  { field: FormFieldNameEnum.Password, type: FormFieldType.Password },
];
